import SelectedStudentsListItem from './selected-students-list-item'

export default SelectedStudentsListItem
